import React, { useContext } from "react";

export interface IDesignSystemGlobals {
    ROOT_ID: string;
}

export const DesignSystemGlobalsContext = React.createContext({ ROOT_ID: "root" });
export const DesignSystemGlobalsProvider = DesignSystemGlobalsContext.Provider;

export const useGlobals = (): IDesignSystemGlobals => {
    const context = useContext<IDesignSystemGlobals>(DesignSystemGlobalsContext);
    return context;
};
